import { stringify } from 'query-string';
import type { Page } from '@jira/platform__rest-page/src/page.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { Sprint } from '../../model/index.tsx';

const getActiveSprints = (boardId: string): Promise<Page<Sprint>> => {
	const params = stringify({
		state: 'active',
	});

	return fetchJson(`/rest/agile/1.0/board/${boardId}/sprint?${params}`);
};

export default getActiveSprints;
